// These functions are helper functions. Use these functions on FE to Send email

import { getFunctions, httpsCallable } from 'firebase/functions'

export type { LearnAlertEvent, LearnAlertPayload } from '../email/learnAlerts'
export { notifyLearnAlert } from '../email/learnAlerts'

export const sendEmail = async (template: string, email: string, data?: any) => {
  const functionsInstance = getFunctions()
  const sendEmail = httpsCallable(functionsInstance, 'default-sendEmail')
  await sendEmail({ template, email, ...data })
}
